import { render, staticRenderFns } from "./MyUpdates.vue?vue&type=template&id=c84e0dc4&scoped=true"
import script from "./MyUpdates.vue?vue&type=script&lang=js"
export * from "./MyUpdates.vue?vue&type=script&lang=js"
import style0 from "./MyUpdates.vue?vue&type=style&index=0&id=c84e0dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e0dc4",
  null
  
)

export default component.exports